import React from "react";
import axios from "axios";
import {NewsFilter} from "../components/shared/Filter"
import {BookResults} from "../components/shared/Result"
import {TopNewsVideos, RelatedSearch, Publishers} from "../components/shared/Section"
import {Pagination} from "../components/shared/Pagination"

export default function Books({keywords, urlPrefix, currentPage, timeFilter, sortByFilter}) {
  const [loading, setLoading] = React.useState(true)
  const [results, setResults] = React.useState(null)

  const totalPages = !loading && results && results.total ? Math.min(Math.ceil(results.total.value/10), 10) : null;

  React.useEffect(()=>{
    axios.get(`${process.env.REACT_APP_API_ENDPOINT}?q=${keywords}&ia=books&fb_lo=${process.env.REACT_APP_DEFAULT_LOCALE}&pdtf=${timeFilter}&sb=${sortByFilter}&offset=${10*(currentPage-1)}`).then((response) => {
      setResults(response.data);
    }).catch((error) => {
      // handle error
      console.log(error);
    }).finally(() => {
      setLoading(false);
    });
  }, [])

  return (
    <main className="search-ct" role="main">
      <div className="search-cs">
	  {/*<NewsFilter timeFilter={timeFilter} sortByFilter={sortByFilter} urlPrefix={urlPrefix}/>*/}
        <div className="l-search">
          <div className="spacing-b-lg">
              {loading &&
                <ul className="news-list list divider md no-bullet"><li><div className="quiet fz13">loading...</div></li></ul>
              }
              {!loading && results && results.total.value === 0 &&
                <ul className="news-list list divider md no-bullet"><li><div className="quiet fz13">No results found for "<strong>{keywords}</strong>".</div></li></ul>
              }
              {!loading && results &&
                <BookResults items={results.hits} />
              }
              {!loading && results && results.total.value !== 0 &&
                <Pagination currentPage={currentPage} totalPages={totalPages} />
              }
          </div>
          <div>
            {/*<TopNewsVideos />*/}
	    {/*<Publishers />*/}
            {/*<RelatedSearch />*/}
          </div>
        </div>
      </div>
    </main>
  );
}
